// Mock user profiles for Antasis Ecosystem SSO testing

export const mockProfiles = {
  agent: {
    id: 'agent',
    email: 'agent@antasis.local',
    name: 'Sarah Johnson',
    role: 'Agent',
    avatar: '👤',
    department: 'Customer Service',
    phone: '+1 (555) 123-4567',
    lastLogin: 'Today, 09:30 AM'
  },
  support: {
    id: 'support',
    email: 'support@antasis.local',
    name: 'Marcus Chen',
    role: 'Support Specialist',
    avatar: '🎧',
    department: 'Technical Support',
    phone: '+1 (555) 234-5678',
    lastLogin: 'Today, 08:15 AM'
  },
  management: {
    id: 'management',
    email: 'management@antasis.local',
    name: 'Dr. Elena Rossi',
    role: 'Management',
    avatar: '👔',
    department: 'Operations',
    phone: '+1 (555) 345-6789',
    lastLogin: 'Today, 07:45 AM'
  }
};

export const getUserProfile = (role) => {
  return mockProfiles[role] || mockProfiles.agent;
};
